import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNotification } from "store/auth/profile/profileSlice";
import NotificationsList from "./NotificationsList";

const Notifications = () => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.Profile.profile);
  const notifications = useSelector((state) => state.Profile.notifications.notifications)
  useEffect(() => {
    dispatch(getNotification(profile?._id));
  }, [dispatch, profile]);
  return (
    <div className="py-4">
      <div className="
            container
            bg-light
            rounded-3
            shadow-sm
            p-3 p-sm-4 p-md-5
            mx-auto
          "
      >
        <NotificationsList notifications={notifications} />
      </div>
    </div>
  )
}

export default Notifications
